import React from "react";
import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { MobilePhlebotomyLink } from "../types";
import BaseCard from "../components/BaseCard";
import {
  LocationName,
  LocationTitleRow,
  PhlebotomyCardActionsRow,
  PhlebotomyPrimaryActionButton,
} from "../components/BaseCard.styles";
import PhlebotomyCardMetadata from "../components/PhlebotomyCardMetadata";

interface MobilePhlebotomyWebsiteCardProps {
  link: MobilePhlebotomyLink;
  onSchedule: (link: MobilePhlebotomyLink) => void;
}

const MobilePhlebotomyWebsiteCard: React.FC<
  MobilePhlebotomyWebsiteCardProps
> = ({ link, onSchedule }) => {
  const { t } = useTranslation();
  const handleSchedule = (event: React.MouseEvent) => {
    event.stopPropagation();
    onSchedule(link);
  };

  return (
    <BaseCard
      showBorder={false}
      actions={
        <PhlebotomyCardActionsRow
          sx={{
            justifyContent: "center",
            "& > .MuiButton-root:only-child": { marginLeft: 0 },
          }}
        >
          <PhlebotomyPrimaryActionButton
            variant="unity-primary"
            onClick={handleSchedule}
            startIcon={<FontAwesomeIcon icon={faCalendar} />}
          >
            {t("phlebotomySearch.mobileOptions.scheduleOnline")}
          </PhlebotomyPrimaryActionButton>
        </PhlebotomyCardActionsRow>
      }
    >
      <Box sx={{ width: "100%" }}>
        <LocationTitleRow sx={{ justifyContent: "center" }}>
          <LocationName sx={{ textAlign: "center" }}>{link.name}</LocationName>
        </LocationTitleRow>
        <Box sx={{ textAlign: "center" }}>
          <PhlebotomyCardMetadata
            lines={link.notes}
            keyPrefix={`website-${link.link}`}
            splitHours={false}
          />
        </Box>
      </Box>
    </BaseCard>
  );
};

export default MobilePhlebotomyWebsiteCard;
